import React, { useState } from 'react';
import 'react-h5-audio-player/lib/styles.css';
import AudioPlayer from 'react-h5-audio-player';

function RecordingPage() {
    const [showPopup, setShowPopup] = useState(false);
    const recordings = [
        { id: 1, src: "https://ztalk.in:5112/uploads/1718621687247-audiorecordtest.mp4", timestamp: "2024-06-17 16:24:47", name: "Nitin " },
        { id: 2, src: "https://ztalk.in:5112/uploads/1718621687247-audiorecordtest.mp4", timestamp: "2024-06-18 10:30:15", name: "Anurag " },
        { id: 3, src: "https://ztalk.in:5112/uploads/1718621687247-audiorecordtest.mp4", timestamp: "2024-06-19 14:12:59", name: "Raj Mistri" },
        { id: 4, src: "https://ztalk.in:5112/uploads/1718621687247-audiorecordtest.mp4", timestamp: "2024-06-20 09:45:21", name: "Pulkesh" },
        { id: 5, src: "https://ztalk.in:5112/uploads/1718621687247-audiorecordtest.mp4", timestamp: "2024-06-17 16:24:47", name: "Nitin " },
        { id: 6, src: "https://ztalk.in:5112/uploads/1718621687247-audiorecordtest.mp4", timestamp: "2024-06-18 10:30:15", name: "Anurag " },
        { id: 7, src: "https://ztalk.in:5112/uploads/1718621687247-audiorecordtest.mp4", timestamp: "2024-06-19 14:12:59", name: "Raj Mistri" },
        { id: 8, src: "https://ztalk.in:5112/uploads/1718621687247-audiorecordtest.mp4", timestamp: "2024-06-20 09:45:21", name: "Pulkesh" }
    ];

    const formatTimestamp = (timestamp) => {
        const optionsDate = { day: '2-digit', month: 'long', year: 'numeric' };
        const optionsTime = { hour: '2-digit', minute: '2-digit', hour12: false };
        const date = new Date(timestamp).toLocaleDateString('en-US', optionsDate);
        const time = new Date(timestamp).toLocaleTimeString('en-US', optionsTime);
        return `${date}, ${time}`;
    };

    return (
        <>
            <section style={{ marginTop: '1rem' }}>
                <div className="container">
                    <div className="d-flex justify-content-center">
                        <button
                            className="btn  bg-white text-danger px-5 shadow"
                            onClick={() => setShowPopup(true)}
                        >
                            <i className="fas fa-trash text-danger"></i> Delete All
                        </button>
                    </div>
                </div>
            </section>
            <section style={{ padding: '2rem 0' }}>
                <div className="container">
                    <div className="row">
                        {recordings.map((recording) => (
                            <div key={recording.id} className="col-sm-6 col-md-4 mb-4">
                                <div className="card shadow" style={{ backgroundColor: 'rgb(22, 78, 99)', borderRadius: '0.5rem' }}>
                                    <div className="card-body position-relative">
                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                            <h5 className="card-title text-white" style={{ fontSize: '1rem', fontWeight: 'bold' }}>{recording.name}</h5>
                                            <h6 className="card-subtitle text-white" style={{ fontSize: '0.875rem' }}>{formatTimestamp(recording.timestamp)}</h6>
                                        </div>
                                        <AudioPlayer
                                            src={recording.src}
                                            onPlay={() => console.log("Playing...")}
                                            style={{ width: '100%', marginTop: '10px', borderRadius: "10px" }}
                                            customVolumeControls={[]}
                                            customAdditionalControls={[
                                                <a
                                                    key={`download-${recording.id}`}
                                                    href={recording.src}
                                                    download
                                                    className="btn btn-sm btn-primary"
                                                    style={{ padding: '0.25rem 0.5rem' }}
                                                >
                                                    <i className="fas fa-download"></i>
                                                </a>
                                            ]}
                                        />
                                        <button className="btn btn-sm btn-danger position-absolute" style={{ top: '-1rem', right: '-0.6rem' }}>
                                            <i className="fas fa-trash"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
            {showPopup && (
                <div className="position-fixed top-0 start-0 end-0 bottom-0 d-flex justify-content-center align-items-center" style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)', zIndex: 1050 }}>
                    <div className="bg-white p-4 rounded shadow-lg">
                        <h3 className="mb-4">Confirm Delete</h3>
                        <p className="mb-4">Are you sure you want to delete all recordings?</p>
                        <div className="d-flex justify-content-end">
                            <button
                                className="btn btn-danger me-2"
                                onClick={() => {
                                    // Handle delete all logic here
                                    setShowPopup(false);
                                }}
                            >
                                Confirm Delete
                            </button>
                            <button
                                className="btn btn-secondary"
                                onClick={() => setShowPopup(false)}
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default RecordingPage;
